export default "__VITE_ASSET__09279af4__"